import React from 'react'
import Typography from '../../../components/Basics/Typography'
import { experience } from '../content/profile.content'
import {
  Container,
  Entry,
  Meta,
  Role,
  Summary,
  Timeline,
} from './Experience.styles'

const Experience = () => {
  return (
    <Container id="experience">
      <Typography variant="h1">Experience</Typography>
      <Timeline>
        {experience.map((item) => (
          <Entry key={`${item.company}-${item.period}`}>
            <Role>{item.role}</Role>
            <Meta>
              {item.company} · {item.period} · {item.location}
            </Meta>
            <Summary>{item.summary}</Summary>
          </Entry>
        ))}
      </Timeline>
    </Container>
  )
}

export default Experience
